import { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { DocumentPreviewContext } from './context';
/**
 * Keeps track of which document is previewed in the `DocumentPreviewSidebar`.
 */
export function DocumentPreviewProvider(props) {
    const { children } = props;
    const { pathname } = useLocation();
    const [documentId, setDocumentId] = useState();
    const [documentIds, setDocumentIds] = useState([]);
    const previewDocument = useCallback((id) => setDocumentId(id), []);
    const closePreview = useCallback(() => setDocumentId(undefined), []);
    const isPreviewing = Boolean(documentId);
    const index = documentId ? documentIds.indexOf(documentId) : -1;
    const previousDocumentId = index > 0 ? documentIds[index - 1] : undefined;
    const nextDocumentId = index >= 0 ? documentIds[index + 1] : undefined;
    useEffect(() => {
        closePreview();
    }, [pathname, closePreview]);
    const value = useMemo(() => ({
        documentId,
        previousDocumentId,
        nextDocumentId,
        previewDocument,
        closePreview,
        setDocumentIds,
        isPreviewing,
    }), [documentId, previousDocumentId, nextDocumentId, previewDocument, closePreview, isPreviewing]);
    return <DocumentPreviewContext.Provider value={value}>{children}</DocumentPreviewContext.Provider>;
}
